import { useContext } from 'react';

import { HistogramXAxisConfigContext } from '../contexts/HistogramXAxisConfig.context.js';

export const useXAxisConfig = () => useContext(HistogramXAxisConfigContext);
